// Interface for Booking Data
interface BookingInitData {
    room_id: string;
    game_id: string;
    date: string;
    slot_time: string;
    players: string;
}

export default class bookingInitDataStorage{ 

    /**
     * Get local storage values
     * @returns 
     */
    getLocalStorage() : BookingInitData | null{
        
        try{
            
            const storedData = localStorage.getItem('booking-init-data-order');

            if(!storedData) return null;
            
            const parsedData: BookingInitData = JSON.parse(storedData);

            return parsedData;

        }catch(error){
            
            return null;

        }

    }

    /**
     * Set local storage
     * @param data 
     */
    setLocalStorage(data: BookingInitData): void{ 

        localStorage.setItem('booking-init-data-order', JSON.stringify(data));

    }

    /**
     * Remove local storage values
     */
    removeStoredValue(){

        localStorage.removeItem('booking-init-data-order');
        
    }

}